(() => {
  document.querySelectorAll('.wb3:not([data-wb3-ready])').forEach((root) => {
    root.dataset.wb3Ready = 'true';
    root.querySelectorAll('[data-wb3-row]').forEach((row) => {
      const controls = Array.from(root.querySelectorAll('[aria-controls="' + row.id + '"]'));
      const update = () => controls.forEach((button) => {
        button.closest('[data-wb3-controls]').hidden = row.scrollWidth <= row.clientWidth + 2;
        button.disabled = button.dataset.wb3Direction === '-1' ? row.scrollLeft <= 2 : row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
      });
      controls.forEach((button) => button.addEventListener('click', () => {
        row.scrollBy({left: Number(button.dataset.wb3Direction) * row.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      row.addEventListener('scroll', update, {passive: true});
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(row);
      row.addEventListener('focusin', (event) => {
        const item = event.target.closest('.wb3-route, .wb3-native-card');
        if (!item || row.scrollWidth <= row.clientWidth) return;
        requestAnimationFrame(() => {
          const box = item.getBoundingClientRect(), frame = row.getBoundingClientRect();
          if (box.right > frame.right - 8) row.scrollLeft += box.right - frame.right + 8;
          else if (box.left < frame.left + 8) row.scrollLeft += box.left - frame.left - 8;
        });
      });
      update();
    });
  });
})();
